var _defs, _circle, _rect, _path, _path2, _rect2, _path3, _circle2, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 447.22 406.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#231f20;stroke-width:17px;}.cls-1,.cls-2{stroke-miterlimit:10;}.cls-2{fill:none;stroke:#121212;stroke-width:14px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 223.17,
    cy: 101.08,
    r: 47.29
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 164.84,
    y: 204.33,
    width: 23.64,
    height: 308.18,
    transform: "translate(176.36 -128.41) rotate(36.56)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.91,498.72l22.46-9.49-18.8-14.71Z",
    transform: "translate(-71.91 -93.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.16,269c27.48,60.27,96.24,103,176.73,103,87.73,0,161.53-50.76,183.13-119.68",
    transform: "translate(-71.91 -93.7)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 402.56,
    y: 205.99,
    width: 23.64,
    height: 308.18,
    transform: "translate(889.8 308.76) rotate(143.44)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M519.13,500.37l-22.45-9.48,18.8-14.72Q517.31,488.28,519.13,500.37Z",
    transform: "translate(-71.91 -93.7)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.17,
    cy: 101.08,
    r: 27.48
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 208.46,
    width: 29.42,
    height: 58.9,
    rx: 12
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.7e15990c.svg";
export { ForwardRef as ReactComponent };